import { CurrencyTypes, TimeZonesEnum } from '@ep/shared';
import { LanguageTypes, LocationStatusTypes } from '../enums';

export interface Location {
  $id?: string;
  LocationId: number;
  MerchantId: number;
  Name: string;
  Address?: string;
  PhoneNumber?: string;
  LanguageType?: LanguageTypes;
  CurrencyType?: CurrencyTypes;
  TimeZoneType?: TimeZonesEnum;
  StatusType?: LocationStatusTypes;
  Latitude?: number;
  Longitude?: number;
}
